export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';

export const GET_MENU_SUCCESS = 'GET_MENU_SUCCESS';
export const GET_LIST_SUCCESS = 'GET_LIST_SUCCESS';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';

export const GET_MENU_FAIL = 'GET_MENU_FAIL';
export const GET_LIST_FAIL = 'GET_LIST_FAIL';
export const GET_ITEMS_FAIL = 'GET_ITEMS_FAIL';

export const GET_CUSTOMER_SUCCESS = 'GET_CUSTOMER_SUCCESS';
export const GET_CUSTOMER_FAILED = 'GET_CUSTOMER_FAILED';

export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_TAGS_FAIL = 'GET_TAGS_FAIL';


// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js